module.exports = __webpack_public_path__ + "img/school-project-active.7399fece.svg";